/*
 * I provide a very primitive auditing framework for "stuff".
 */
import Dispatcher from "Dispatcher";

const SKELETON = {
    _count: 0,
    _elapsed: 0, // this is gonna be BS, because of nesting!
    _flux: {
        count: 0,
        elapsed: 0,
    },
    _ui: {
        count: 0,
        elapsed: 0,
    },
    push(name, elapsed) {
        if (!window.audit.hasOwnProperty(name)) {
            window.audit[name] = {
                count: 0,
                elapsed: 0,
                flux: {
                    count: 0,
                    elapsed: 0,
                },
                ui: {
                    count: 0,
                    elapsed: 0,
                },
                samples: [],
            };
        }
        window.audit._count += 1;
        window.audit._elapsed += elapsed;
        const bucket = window.audit[name];
        bucket.count += 1;
        bucket.elapsed += elapsed;
        if (Dispatcher.isDispatching()) {
            window.audit._flux.count += 1;
            window.audit._flux.elapsed += elapsed;
            bucket.flux.count += 1;
            bucket.flux.elapsed += elapsed;
        } else {
            window.audit._ui.count += 1;
            window.audit._ui.elapsed += elapsed;
            bucket.ui.count += 1;
            bucket.ui.elapsed += elapsed;
        }
        if (bucket.count <= 100) {
            bucket.samples.push(elapsed);
        }
    },
    reset() {
        window.audit = {...SKELETON};
    },
};

SKELETON.reset();

export const auditable = (name, fn) => {
    if (typeof name === "function") {
        console.warn("unnamed auditable created");
        fn = name;
        name = "_unnamed_auditable_";
    }
    return function (...args) {
        const s = Date.now();
        const r = fn.apply(this, args);
        const e = Date.now() - s;
        window.audit.push(name, e);
        return r;
    };
};

export const audit = (name, work) => {
    if (typeof name === "function") {
        console.warn("unnamed audit performed");
        work = name;
        name = "_unnamed_audit_";
    }
    return auditable(name, work)();
};



// WEBPACK FOOTER //
// ./app/audit.js